import React from 'react';
// import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setDashBoardIsActive} from "../../../Features/Misc/activeSlice";
import {setWatchIsActive} from "../../../Features/Misc/navBarSlice";
import ExploreEverythingButton from "../../Components/ExploreEverythingButton";

const LandingTitle = () => {
    // const { user } = useSelector((state) => state.auth)
    // const dispatch = useDispatch()

    // const handleClick = () => {
    //     dispatch(setWatchIsActive())
    //     dispatch(setDashBoardIsActive());
    // };

    return (
        <div className="sm:flex justify-between items-center mb-8 lg:mb-12">
            <h2 className="font-semibold text-white mb-6 sm:mb-0 sm:text-xl lg:text-4xl">What's your problem?</h2>

            {/*<button*/}
            {/*    onClick={handleClick}*/}
            {/*    className="*/}
            {/*        flex justify-center items-center text-white bg-gold-accent*/}
            {/*        rounded-lg py-3 px-4 sm:px-16 lg:py-4 lg:px-24 lg:text-xl font-medium cursor-pointer*/}
            {/*         hover:opacity-60 transition-opacity duration-300 transition-background-color*/}
            {/*        "*/}
            {/*>*/}
            {/*    Explore everything*/}
            {/*    <i className="ri-arrow-right-line ml-3 sm:ml-6"></i>*/}
            {/*</button>*/}
            <ExploreEverythingButton />
        </div>
    );
};

export default LandingTitle;